import { FC } from 'react';

import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { REGISTRATION_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import styles from './BannerForRegistration.module.scss';

export const BannerForRegistration: FC = () => {
	const { t } = useTranslation(TranslationNamespace.WarehouseSearch);
	return (
		<div className={styles.registerBanner}>
			<div className={styles.registerBannerTitle}>{t('registration-banner.title')}</div>
			<div className={styles.registerBannerDescription}>{t('registration-banner.description')}</div>
			<Link href={REGISTRATION_URL}>
				<Button type="primary" size="middle">
					{t('register')}
				</Button>
			</Link>
		</div>
	);
};
